// src/components/SidebarProvider.js
import React, { createContext, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const defaultSidebarContext = {
  isMinimized: false,
  toggleSidebar: () => {},
  sidebarAnchor: "left",
  toggleAnchor: () => {},
  contentMargin: {},
  sidebarWidth: "15em",
  isMobile: false,
  mobileOpen: false,
  setMobileOpen: () => {},
  toggleMobileDrawer: () => {},
};

export const SidebarContext = createContext(defaultSidebarContext);

function readSidebarAnchor() {
  try {
    const savedAnchor = localStorage.getItem("sidebarAnchor");
    return savedAnchor && ["left", "right"].includes(savedAnchor)
      ? savedAnchor
      : "left";
  } catch {
    return "left";
  }
}

export const SidebarProvider = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true,
    defaultMatches: false,
  });

  const [isMinimized, setIsMinimized] = useState(false);
  const [sidebarAnchor, setSidebarAnchor] = useState(readSidebarAnchor);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = () => {
    setIsMinimized((prev) => {
      const next = !prev;
      if (next) setMobileOpen(false);
      return next;
    });
  };

  const toggleAnchor = (newValue) =>
    setSidebarAnchor((prev) => {
      if (newValue && ["left", "right"].includes(newValue)) return newValue;
      return prev === "left" ? "right" : "left";
    });

  const toggleMobileDrawer = () => setMobileOpen((prev) => !prev);

  const expandedWidth = "15em";

  const sidebarWidth = isMobile || isMinimized ? "0px" : expandedWidth;

  const contentMargin =
    isMobile || isMinimized
      ? {}
      : sidebarAnchor === "left"
        ? { marginLeft: sidebarWidth }
        : { marginRight: sidebarWidth };

  return (
    <SidebarContext.Provider
      value={{
        isMinimized: isMobile ? false : isMinimized,
        toggleSidebar,
        sidebarAnchor,
        toggleAnchor,
        contentMargin,
        sidebarWidth,
        isMobile,
        mobileOpen,
        setMobileOpen,
        toggleMobileDrawer,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
